import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { ODS_ITEMS, ODS_TOTAL, OdsItem } from 'src/app/shared/constants/ods-items.constant';

@Component({
  standalone: false,
  selector: 'app-psa-checkbox-group-ods',
  templateUrl: './psa-checkbox-group-ods.component.html',
  styleUrls: ['./psa-checkbox-group-ods.component.scss'],
})
export class CheckboxGroupOdsComponent implements OnInit, OnDestroy {
  @Input() formRegister!: FormGroup;

  readonly odsItems: OdsItem[] = ODS_ITEMS;
  readonly odsTotal = ODS_TOTAL;

  selectAll = false;
  private odsNumbersSubscription?: Subscription;

  get selectedCount(): number {
    return this.getSelectedValues().length;
  }

  ngOnInit(): void {
    this.syncSelectAllState();
    this.odsNumbersSubscription = this.formRegister.get('odsNumbers')?.valueChanges.subscribe(() => {
      this.syncSelectAllState();
    });
  }

  ngOnDestroy(): void {
    this.odsNumbersSubscription?.unsubscribe();
  }

  isSelected(id: number): boolean {
    return this.getSelectedValues().includes(id);
  }

  toggleOds(id: number): void {
    const selected = new Set(this.getSelectedValues());

    if (selected.has(id)) {
      selected.delete(id);
    } else {
      selected.add(id);
    }

    this.updateOdsNumbers([...selected].sort((a, b) => a - b));
  }

  onSelectAllToggle(event: Event): void {
    const checked = (event.target as HTMLInputElement).checked;
    this.selectAll = checked;
    this.updateOdsNumbers(checked ? this.odsItems.map(item => item.id) : []);
  }

  trackByOdsId(_index: number, item: OdsItem): number {
    return item.id;
  }

  private getSelectedValues(): number[] {
    return this.formRegister.get('odsNumbers')?.value ?? [];
  }

  private updateOdsNumbers(values: number[]): void {
    this.formRegister.get('odsNumbers')?.setValue(values);
    this.formRegister.get('odsNumbers')?.markAsDirty();
  }

  private syncSelectAllState(): void {
    this.selectAll = this.selectedCount === this.odsTotal;
  }
}
